"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _invoice = require("@/api/invoice");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'InvoiceList',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: 15,
        invoiceNo: ''
      },
      statistics: {
        amount: '53000.00',
        taxAmount: '53000.00',
        totalAmount: '53000.00'
      },
      tableData: {
        list: [],
        total: 0
      },
      // 展开行相关数据
      expandedRows: [],
      // 当前展开的行的key数组
      expandData: {},
      // 展开行的详情数据,key为invoiceNo
      expandLoading: {},
      // 展开行的加载状态,key为invoiceNo
      expandPagination: {} // 展开行明细的分页参数,key为invoiceNo
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _invoice.getInvoiceList)(this.searchForm).then(function (res) {
        _this.tableData.list = res.list || [];
        _this.tableData.total = res.total || 0;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 处理展开行变化
    handleExpandChange: function handleExpandChange(row, expandedRows) {
      var invoiceNo = row.invoiceNo;
      var isExpanding = expandedRows.some(function (r) {
        return r.invoiceNo === invoiceNo;
      });
      if (isExpanding) {
        // 展开时加载数据
        this.expandedRows = [invoiceNo]; // 只允许展开一行
        this.loadExpandData(invoiceNo);
      } else {
        // 收起时清空当前行数据
        this.expandedRows = [];
      }
    },
    // 加载展开行的详情数据
    loadExpandData: function loadExpandData(invoiceNo) {
      var _this2 = this;
      // 初始化分页参数
      if (!this.expandPagination[invoiceNo]) {
        this.$set(this.expandPagination, invoiceNo, {
          page: 1,
          limit: 10
        });
      }
      this.$set(this.expandLoading, invoiceNo, true);
      var params = {
        page: this.expandPagination[invoiceNo].page,
        limit: this.expandPagination[invoiceNo].limit
      };
      (0, _invoice.getInvoiceInfo)(invoiceNo, params).then(function (res) {
        _this2.$set(_this2.expandData, invoiceNo, res || {});
        _this2.$set(_this2.expandLoading, invoiceNo, false);
      }).catch(function () {
        _this2.$set(_this2.expandLoading, invoiceNo, false);
      });
    },
    // 明细分页大小改变
    handleDetailSizeChange: function handleDetailSizeChange(val, invoiceNo) {
      this.expandPagination[invoiceNo].limit = val;
      this.expandPagination[invoiceNo].page = 1;
      this.loadExpandData(invoiceNo);
    },
    // 明细页码改变
    handleDetailPageChange: function handleDetailPageChange(val, invoiceNo) {
      this.expandPagination[invoiceNo].page = val;
      this.loadExpandData(invoiceNo);
    },
    // 查询
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.expandedRows = []; // 收起所有展开行
      this.getList();
    },
    // 重置
    handleReset: function handleReset() {
      this.searchForm.invoiceNo = '';
      this.searchForm.page = 1;
      this.expandedRows = []; // 收起所有展开行
      this.getList();
    },
    // 操作按钮
    handleAction: function handleAction(type) {
      switch (type) {
        case 'importBase':
          this.$refs.refImportBase.click();
          break;
        case 'exportBase':
          this.handleExportBase();
          break;
        case 'importSummary':
          this.$refs.refImportSummary.click();
          break;
        case 'exportSummary':
          this.handleExportSummary();
          break;
      }
    },
    // 导入发票基础信息
    uploadBase: function uploadBase(e) {
      var _this3 = this;
      var file = e.target.files[0];
      if (!file) return;
      var formData = new FormData();
      formData.append('file', file);
      var loading = this.$loading({
        lock: true,
        text: '正在导入发票基础信息...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _invoice.invoiceImportBase)(formData).then(function (res) {
        _this3.$message.success('导入成功');
        _this3.getList();
        _this3.$refs.refImportBase.value = null;
        loading.close();
      }).catch(function () {
        _this3.$refs.refImportBase.value = null;
        loading.close();
      });
    },
    // 导入汇总工表单
    uploadSummary: function uploadSummary(e) {
      var _this4 = this;
      var file = e.target.files[0];
      if (!file) return;
      var formData = new FormData();
      formData.append('file', file);
      var loading = this.$loading({
        lock: true,
        text: '正在导入汇总工表单...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _invoice.invoiceImportSummary)(formData).then(function (res) {
        _this4.$message.success('导入成功');
        _this4.$refs.refImportSummary.value = null;
        loading.close();
      }).catch(function () {
        _this4.$refs.refImportSummary.value = null;
        loading.close();
      });
    },
    // 导出发票基础信息
    handleExportBase: function handleExportBase() {
      this.$message.info('当前导出功能细节正在完善');
      // const loading = this.$loading({
      //   lock: true,
      //   text: '正在生成导出文件...',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })
      // invoiceExportBase(this.searchForm).then(res => {
      //   if (res.fileName) {
      //     window.location.href = res.fileName
      //   } else {
      //     this.$message.warning('未获取到下载链接')
      //   }
      //   loading.close()
      // }).catch(() => {
      //   loading.close()
      // })
    },
    // 导出汇总工表单
    handleExportSummary: function handleExportSummary() {
      this.$message.info('当前导出功能细节正在完善');
      // const loading = this.$loading({
      //   lock: true,
      //   text: '正在生成导出文件...',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })
      // invoiceExportSummary(this.searchForm).then(res => {
      //   if (res.fileName) {
      //     window.location.href = res.fileName
      //   } else {
      //     this.$message.warning('未获取到下载链接')
      //   }
      //   loading.close()
      // }).catch(() => {
      //   loading.close()
      // })
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.searchForm.page = 1;
      this.expandedRows = []; // 收起所有展开行
      this.getList();
    },
    // 页码改变
    pageChange: function pageChange(val) {
      this.searchForm.page = val;
      this.expandedRows = []; // 收起所有展开行
      this.getList();
    }
  }
};